/**
 * Production guard -- prevents mock data from being shown in production.
 *
 * In development mode, panels fall back to demo/mock data when API calls fail.
 * In production mode, panels show an error state instead, so operators never
 * see fabricated metrics and mistake them for real telemetry.
 */

export function isProduction(): boolean {
  return import.meta.env.PROD || import.meta.env['VITE_NODE_ENV'] === 'production';
}

export function isDevelopment(): boolean {
  return import.meta.env.DEV || import.meta.env['VITE_NODE_ENV'] === 'development';
}

/**
 * Returns fallback data only if NOT in production mode.
 * In production, returns null (component should show error state).
 */
export function safeFallback<T>(fallbackData: T): T | null {
  if (isProduction()) return null;
  return fallbackData;
}
